import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ComponentTag from '@cred/react-component-tag'
import { ALL_COLOR_NAMES } from '@cred/react-theme/colors'

import { getKeyDownProps } from './utils'
import styles from './styles.module.scss'
import * as packageJson from './package.json'
import legacyColorMap from './legacyColorMap'

class LinkComponent extends Component {
  static propTypes = {
    type: PropTypes.oneOf([ // Backwards compatibility with react-font, prefer using className instead
      'inherit',
      'disclaimer',
      'capsHeading',
      'bodySmall',
      'body',
      'bodyLarge',
      'heading',
      'medium',
      'large',
      'xLarge',
    ]),
    href: PropTypes.string,
    color: PropTypes.oneOf([ // Backwards compatibility with react-font, prefer using className instead
      'inherit',
      'lighter',
      'lighter2',
      'accent',
      'accent2',
      'darkGrey',
      ...ALL_COLOR_NAMES
    ]),
    weight: PropTypes.oneOf([
      'inherit',
      'regular',
      'semiBold',
      'bold',
      'extraBold',
    ]), // Backwards compatibility with react-font, prefer using className instead
    underline: PropTypes.oneOf(['none', 'dashed', 'solid', 'noneHover']),
    blank: PropTypes.bool,
    rel: PropTypes.string,
    tabIndex: PropTypes.number,
    onKeyDown: PropTypes.func,
    ignoreKeyDown: PropTypes.bool,
  }

  static defaultProps = {
    type: null,
    href: null,
    color: null,
    weight: null,
    underline: 'none',
    blank: false,
    rel: '',
    tabIndex: 0,
    onKeyDown: undefined,
    ignoreKeyDown: false
  }

  constructor(props) {
    super(props)

    this.onClickHandler = this.onClickHandler.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  onClickHandler(proxy) {
    const {onClick} = this.props

    if (onClick) {
      onClick(proxy)
    }
  }

  setRef(ref) {
    this.ref = ref
  }

  click() {
    if (this.ref) {
      this.ref.click()
    }
  }

  focus() {
    if (this.ref) {
      this.ref.focus()
    }
  }

  render() {
    const {
        underline,
        blank,
        className,
        href,
        onClick,
        rel,
        analytics,
        defaultAnalytics,
        match,
        location,
        history,
        staticContext,
        analyticsContexts,
        analyticsOptions,
        overwriteContexts,
        snowplowEvent,
        analyticsText,
        tabIndex,
        onKeyDown,
        ignoreKeyDown,
        componentTag,
        color, // Backwards compatibility with react-font
        type, // Backwards compatibility with react-font
        weight, // Backwards compatibility with react-font
        ...props
      } = this.props

      const keyDownProps = getKeyDownProps({onKeyDown, ignoreKeyDown, href})

    let safeRel = rel

    if ((blank || (props.target || '').toLowerCase() === '_blank') && !rel.includes('noopener')) {
      safeRel += ' noopener'
    }

    return (
      <a
        className={cx(className, styles[underline], styles.link, { [type]: !!type, [weight]: !!weight, [legacyColorMap(color)]: !!color })}
        href={href}
        rel={safeRel.trim()}
        ref={this.setRef}
        onClick={this.onClickHandler}
        target={blank ? '_blank' : '_self'}
        tabIndex={tabIndex}
        {...componentTag}
        {...keyDownProps}
        {...props}
      />
    )
  }
}

const Link = ComponentTag(packageJson)(LinkComponent)

export {Link}

export default Link
